import { render, staticRenderFns } from "./NavImage.vue?vue&type=template&id=ed56c4e2&scoped=true"
import script from "./NavImage.vue?vue&type=script&lang=js"
export * from "./NavImage.vue?vue&type=script&lang=js"
import style0 from "./NavImage.vue?vue&type=style&index=0&id=ed56c4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed56c4e2",
  null
  
)

export default component.exports